<template>
  <div>
    <cis-with-detail
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sideBarData"
    ></cis-with-detail>
    <vs-table id="userWantsTable" :data="wants"
      @selected="handleSelected">
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row
            id="panelHeaderRow"
            v-show="!isFilterActive"
            vs-type="flex"
            vs-w="12"
            vs-justify="space-between"
          >
            <vs-col
              id="panel-actions"
              vs-type="flex"
              class="w-auto"
              vs-justify="center"
            >
              <vs-row style="margin-top: 1rem; margin-left: 1rem;" vs-type="flex" vs-w="12">
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Yeni İstek" position="top">
                    <vs-button
                    @click="newFormPopupActive = true"
                    class="panel-action text-success xlarge-button panel-action-box-shadow"
                    color="transparent"
                    icon-pack="feather"
                    icon="icon-plus"
                  >
                  </vs-button>
                </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Detaylı Filtereleme" position="top">
                    <vs-button
                      @click="isFilterActive = !isFilterActive"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="pickicon"
                      icon="icon-pick-filter"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Excel'e Aktar" position="top">
                    <vs-button @click="getExcel" class="panel-action text-dark xlarge-button panel-action-box-shadow"
                               color="transparent" icon-pack="feather" icon="icon-download">
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col
                  vs-type="flex"
                  class="w-auto"
                  v-for="(chip, index) in filterChips"
                  :key="index"
                >
                  <vs-chip
                    color="white"
                    class="panel-action-box-shadow px-1"
                    @click="removeFilter(chip.col, index)"
                    v-show="chip.value != ''"
                    closable
                  >
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + " :" }}
                        </span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        class="w-auto ml-1"
                        vs-align="center"
                      >
                        <feather-icon
                          v-if="chip.value === true"
                          icon="CheckIcon"
                          svgClasses="w-4 h-4 text-primary"
                        />
                        <feather-icon
                          v-else-if="chip.value === false"
                          icon="XIcon"
                        />
                        <span
                          v-else
                          class="weight-600 italic text-xsmaller text-primary"
                        >
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th class="w-1/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="currentSortField == 'created' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('created')"
            >Tarih
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="currentSortField == 'createdTime' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('createdTime')"
            >Saat
          </vs-button>
        </vs-th>
        <vs-th class="w-3/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="currentSortField == 'title' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('title')"
            >Konu
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="currentSortField == 'branchName' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('branchName')"
            >Şube
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="currentSortField == 'userName' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('userName')"
            >Kişi
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="currentSortField == 'assignedTo' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('assignedTo')"
            >Atanan
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="currentSortField == 'status' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('status')"
            >Durum
          </vs-button>
        </vs-th>
        <vs-th v-if="$isSuperAdmin()" class="w-1/12">
          <span class="p-1 weight-600">İşlemler</span>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td class="w-1/12">
            {{ formatDate(tr.created) }}
          </vs-td>
          <vs-td class="w-1/12">
            {{ formatTime(tr.created) }}
          </vs-td>
          <vs-td class="w-3/12">
            {{ tr.title }}
          </vs-td>
          <vs-td class="w-2/12">
            {{ tr.branchName }}
          </vs-td>
          <vs-td class="w-2/12">
            {{ tr.userName }}
          </vs-td>
          <vs-td class="w-2/12">
            {{ tr.categoryName || '-' }}
          </vs-td>
          <vs-td class="w-1/12">
            <vs-chip :color="getStatusColor(tr.status)">
              {{ getStatusText(tr.status) }}
            </vs-chip>
          </vs-td>
          <vs-td v-if="$isSuperAdmin()" class="w-1/12">
            <vs-button
              color="danger"
              icon-pack="feather"
              icon="icon-trash-2"
              @click.stop="confirmDelete(tr)"
            ></vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-popup fullscreen title="Yeni İstek" :active.sync="newFormPopupActive">
      <vs-row vs-w="12">
        <vs-col vs-offset="3" vs-justify="center" vs-align="center" vs-w="6" class="px-2">
          <form data-vv-scope="form-1" @keyup.enter="submitData">
            <vs-row class="mb-6">
              <div class="w-full">
                <vs-input label-placeholder="İstek Başlığı" v-validate="'required|min:2|max:60'" name="Başlık" v-model="newWant.title" class="w-full" size="large" vs-type="flex"/>
                <span class="text-danger text-sm" v-show="errors.has('form-1.Başlık')">{{ errors.first('form-1.Başlık')}}</span>
              </div>
            </vs-row>
            <vs-row class="mb-6">
              <div class="w-full">
                <v-select
                  v-model="newWant.category"
                  :options="categories"
                  itemid="id" label="name"
                  v-validate="'required'"
                  name="Kategori" placeholder="Kategori Seçimi.."
                >
                </v-select>
                <span class="text-danger text-sm" v-show="errors.has('form-1.Kategori')">{{ errors.first('form-1.Kategori')}}</span>
              </div>
            </vs-row>
            <vs-row class="mb-6">
              <div class="w-full">
                <vs-textarea label="İstek İçeriği" name="İçerik" v-validate="'required|min:2'" size="large" v-model="newWant.content" />
                <span class="text-danger text-sm" v-show="errors.has('form-1.İçerik')">{{ errors.first('form-1.İçerik')}}</span>
              </div>
            </vs-row>

            <!-- File Upload Section -->
            <vs-row class="mb-6">
              <div class="w-full">
                <label class="vs-input--label">Dosyalar (Toplam max. 3MB)</label>
                <div class="file-upload-container">
                  <input
                    type="file"
                    ref="fileInput"
                    @change="handleFileUpload"
                    multiple
                    class="hidden"
                  />
                  <vs-button
                    icon-pack="feather"
                    icon="icon-upload"
                    @click="$refs.fileInput.click()"
                    :disabled="totalFileSize >= maxTotalSize"
                  >
                    Dosya Ekle
                  </vs-button>
                  <div v-if="totalFileSize > 0" class="mt-2">
                    <span :class="{'text-danger': totalFileSize > maxTotalSize, 'text-success': totalFileSize <= maxTotalSize}">
                      Toplam: {{ formatFileSize(totalFileSize) }} / 3MB
                    </span>
                  </div>
                </div>

                <!-- Selected Files List -->
                <div v-if="selectedFiles.length > 0" class="selected-files mt-3">
                  <ul class="file-list">
                    <li v-for="(file, index) in selectedFiles" :key="index" class="file-item">
                      <span class="file-name">{{ file.name }} ({{ formatFileSize(file.size) }})</span>
                      <vs-button
                        color="danger"
                        icon-pack="feather"
                        icon="icon-x"
                        size="small"
                        @click="removeFile(index)"
                      ></vs-button>
                    </li>
                  </ul>
                </div>
              </div>
            </vs-row>
            <!-- End File Upload Section -->

            <vs-row class="mb-6 " vs-type="flex" vs-w="12">
              <vs-col class="w-full" vs-justify="flex-end" vs-type="flex">
                <vs-button size="large" class="mr-3 mb-2 " type="gradient" color="danger"
                  @click="initNewFormValues()">
                  Vazgeç
                </vs-button>
                <vs-button size="large" class="mb-2 " type="gradient" color="success" @click="submitData">
                  Kaydet
                </vs-button>
              </vs-col>
            </vs-row>
          </form>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import { addUserWant, getAllAdmin, getLogs, changeStatus, getAllAdminExcel, deleteUserWant, uploadFile } from "@/api/UserWant";
import { getAllUserWantCategories } from "@/api/UserWantCategory";
import CisWithDetail from "./CisWithDetail.vue";
import GlobalFilter from "../GlobalFilter";
export default {
  components:{
    CisWithDetail,
    GlobalFilter,
  },
  data() {
    return{
      categories: [],
      wants: [],
      originalData: [],
      newFormPopupActive: false,
      newWant: {
        title: "",
        content: "",
        files: []
      },
      selectedFiles: [],
      totalFileSize: 0,
      maxTotalSize: 3 * 1024 * 1024,
      addNewDataSidebar: false,
      sideBarData: {},
      tableOptions: {},
      sortingHeadIcon: "icon-arrow-down",
      sortingHeadIconBool: 3,
      currentSortField: "created",
      isFilterActive: false,
      filterOptions: [
        "dateRange",
        "branch",
        "personal",
        "wantCategory",
        "status"
      ],
      filterOptionNames: [
        "Tarih",
        "Şube",
        "Personel",
        "İstek Kategori",
        "Durum"
      ],
      isFiltererOpen: false,
      filterChips: [],
      selected: "",
      moment: require('moment-timezone')
    }
  },
  created: async function() {
    await this.loadCategories();
    this.clearFilter();
    // Set initial sort to created date in descending order (newest first)
    this.tableOptions.sortBy = "created";
    this.tableOptions.sortDirection = "desc";
    this.currentSortField = "created";
    this.sortingHeadIcon = "icon-arrow-down";
    this.sortingHeadIconBool = 3;
    this.getDatas();
  },
  watch: {
    tableOptions: {
      deep: true,
      handler(val) {
        if (!val.changedBySort) {
          this.$nextTick(() => {
            this.getDatas();
          });
        }
      },
    },
  },
  methods: {
    formatDate(dateString) {
      return this.moment(dateString).format('DD/MM/YYYY');
    },
    formatTime(dateString) {
      return this.moment(dateString).format('HH:mm');
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Created",
        sortDirection: "desc",
        dateRange: {
          startDate:
            this.$now().getHours() >= 0 && this.$now().getHours() <= 2
              ? this.$preDate()
              : this.$now.date(),
          endDate:
            this.$now().getHours() >= 0 && this.$now().getHours() <= 2
              ? this.$preDate()
              : this.$now.date(),
        },
        timeRange: {
          startTime: null,
          endTime: null,
        },
        branch: null,
        personal: null,
        wantCategory: null
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    setSortingOptions(val) {
      if (this.currentSortField != val) this.sortingHeadIconBool = 1;
      this.currentSortField = val;

      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          this.sortData(val, "asc");
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          this.sortData(val, "desc");
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.currentSortField = "";
          this.wants = [...this.originalData];
          break;
      }
    },
    sortData(field, direction) {
      let sortedData = [...this.wants];

      sortedData.sort((a, b) => {
        let valueA, valueB;

        if (field === 'created') {
          valueA = new Date(a[field]);
          valueB = new Date(b[field]);
        }
        else if (field === 'assignedToName') {
          valueA = a[field] || '';
          valueB = b[field] || '';
        }
        else {
          valueA = a[field];
          valueB = b[field];
        }

        if (typeof valueA === 'string' && typeof valueB === 'string') {
          return direction === 'asc'
            ? valueA.localeCompare(valueB)
            : valueB.localeCompare(valueA);
        } else {
          return direction === 'asc'
            ? (valueA > valueB ? 1 : -1)
            : (valueA < valueB ? 1 : -1);
        }
      });

      this.wants = sortedData;
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      val == false ? (this.selected = "") : null;
    },
    handleSelected(tr) {
      this.sideBarData = tr;
      this.toggleDataSidebar(true);
    },
    getDatas() {
      getAllAdmin(this.tableOptions).then((res)=>{
        if (res && res.status == 200) {
          this.originalData = [...res.data];
          this.wants = [...res.data];

          // Sort by date and time after fetching data (newest first)
          this.sortData('created', 'desc');
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Hata : " + res.status,
          });
        }
      });
    },
    getExcel(){
      // Format and log dates in dd/MM/yyyy format
      let startString = "";
        let endString = "";
      if (this.tableOptions.dateRange) {
        const startDate = this.tableOptions.dateRange.startDate;
        const endDate = this.tableOptions.dateRange.endDate;

        if (startDate) {
          const formattedStartDate = new Date(startDate);
          const startDay = String(formattedStartDate.getDate()).padStart(2, '0');
          const startMonth = String(formattedStartDate.getMonth() + 1).padStart(2, '0');
          const startYear = formattedStartDate.getFullYear();
          startString = `${startDay}_${startMonth}_${startYear}`;
        }

        if (endDate) {
          const formattedEndDate = new Date(endDate);
          const endDay = String(formattedEndDate.getDate()).padStart(2, '0');
          const endMonth = String(formattedEndDate.getMonth() + 1).padStart(2, '0');
          const endYear = formattedEndDate.getFullYear();
          endString = `${endDay}_${endMonth}_${endYear}`;
        }
      }

      getAllAdminExcel(this.tableOptions).then(res => {
        if (res && res.status == 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'İletişim Sistemi Özet Raporu' + startString + " - " + endString + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
    },
    initNewFormValues(){
      this.newWant = {
        title: "",
        content: "",
        files: []
      };
      this.selectedFiles = [];
      this.totalFileSize = 0;
      this.newFormPopupActive = false;
      this.$validator.reset();
    },
    submitData: async function () {
      let checker;
      checker = await this.$validator.validateAll("form-1");
      if(checker){
        try {
          // First upload files if any
          if (this.selectedFiles.length > 0) {
            const filePaths = await this.uploadSelectedFiles();
            this.newWant.files = filePaths;
          } else {
            this.newWant.files = [];
          }

          this.newWant.categoryId = this.newWant.category.id;
          const res = await addUserWant(this.newWant);

          if (res && res.status == 200) {
            this.initNewFormValues();
            this.getDatas();
            this.$vs.notify({
              color: 'success',
              title: 'Başarılı !',
              text: 'İstek Ekleme Başarılı ! '
            });
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata !',
              text: 'İstek Ekleme Başarısız ! '
            });
          }
        } catch (error) {
          let errorMessage = 'İstek Ekleme Başarısız!';
          if (error.response && error.response.data && error.response.data.Errors && error.response.data.Errors.length > 0 && error.response.data.Errors[0].Message) {
            errorMessage = error.response.data.Errors[0].Message;
          }
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: errorMessage
          });
        }
      }
    },
    async loadCategories() {
      try {
        const response = await getAllUserWantCategories();
        this.categories = response.data;
      } catch (error) {
        let errorMessage = 'Kategoriler yüklenirken bir hata oluştu!';
        if (error.response && error.response.data && error.response.data.Errors && error.response.data.Errors.length > 0 && error.response.data.Errors[0].Message) {
          errorMessage = error.response.data.Errors[0].Message;
        }
        this.$vs.notify({
          color: "danger",
          title: "Hata!",
          text: errorMessage
        });
      }
    },
    getStatusText(status) {
      switch (status) {
        case 0:
          return "İletildi";
        case 1:
          return "Süreç Başladı";
        case 2:
          return "Tamamlandı";
        default:
          return "Bilinmiyor";
      }
    },
    getStatusColor(status) {
      switch (status) {
        case 0:
          return "warning";
        case 1:
          return "primary";
        case 2:
          return "success";
        default:
          return "dark";
      }
    },
    handleStatusChange(newStatus, userWantId) {
      const statusData = {
        userWantId: userWantId,
        status: newStatus
      };

      changeStatus(statusData).then(res => {
        if (res && res.status == 200) {
          this.$vs.notify({
            color: 'success',
            title: 'Başarılı!',
            text: 'Durum başarıyla güncellendi'
          });
          this.getDatas(); // Refresh data
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata!',
            text: 'Durum güncellenemedi'
          });
        }
      }).catch((error) => {
        let errorMessage = 'Durum güncellenemedi';
        if (error.response && error.response.data && error.response.data.Errors && error.response.data.Errors.length > 0 && error.response.data.Errors[0].Message) {
          errorMessage = error.response.data.Errors[0].Message;
        }
        this.$vs.notify({
          color: 'danger',
          title: 'Hata!',
          text: errorMessage
        });
      });
    },
    async confirmDelete(item) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'İsteği Sil',
        text: `"${item.title}" istek kaydını silmek istediğinize emin misiniz?`,
        acceptText: 'Sil',
        cancelText: 'İptal',
        buttonColor: '#dc3545',
        cancelColor: '#6e7d88',
        accept: () => this.deleteItem(item.id)
      })
    },
    deleteItem(id) {
      deleteUserWant(id).then(res => {
        if (res && res.status == 200) {
          // Remove from local array to avoid another API call
          this.wants = this.wants.filter(item => item.id !== id);
          this.originalData = this.originalData.filter(item => item.id !== id);

          this.$vs.notify({
            color: 'success',
            title: 'Başarılı!',
            text: 'Kayıt başarıyla silindi'
          });
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata!',
            text: 'Kayıt silinirken bir hata oluştu'
          });
        }
      }).catch((error) => {
        let errorMessage = 'Kayıt silinirken bir hata oluştu';
        if (error.response && error.response.data && error.response.data.Errors && error.response.data.Errors.length > 0 && error.response.data.Errors[0].Message) {
          errorMessage = error.response.data.Errors[0].Message;
        }
        this.$vs.notify({
          color: 'danger',
          title: 'Hata!',
          text: errorMessage
        });
      });
    },
    handleFileUpload(event) {
      const newFiles = Array.from(event.target.files);

      // Check if adding these files would exceed the limit
      const newTotalSize = this.totalFileSize + newFiles.reduce((total, file) => total + file.size, 0);

      if (newTotalSize > this.maxTotalSize) {
        this.$vs.notify({
          color: 'danger',
          title: 'Hata!',
          text: 'Toplam dosya boyutu 3MB\'ı geçemez!'
        });
        // Reset file input
        this.$refs.fileInput.value = '';
        return;
      }

      // Add files to the selected files array
      this.selectedFiles = [...this.selectedFiles, ...newFiles];

      // Update total size
      this.totalFileSize = newTotalSize;

      // Reset file input
      this.$refs.fileInput.value = '';
    },

    removeFile(index) {
      // Update total size before removing file
      this.totalFileSize -= this.selectedFiles[index].size;

      // Remove file from array
      this.selectedFiles.splice(index, 1);
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';

      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    async uploadSelectedFiles() {
      if (this.selectedFiles.length === 0) return [];

      const filePaths = [];

      // Upload each file individually
      for (const file of this.selectedFiles) {
        try {
          const formData = new FormData();
          formData.append('image', file);

          const response = await uploadFile(formData);
          if (response && response.status === 200) {
            // Add the path to our array (assuming the response is the filename or path)
            filePaths.push("StaticFiles/images/" + response.data);
          }
        } catch (error) {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata!',
            text: `${file.name} dosyası yüklenirken hata oluştu`
          });
        }
      }

      return filePaths;
    },
  }
}
</script>

<style scoped>
.w-1\/12 {
  width: 8.333333%;
}
.w-2\/12 {
  width: 16.666667%;
}
.w-3\/12 {
  width: 25%;
}
.vs-component vs-button vs-button-primary vs-button-flat{
  background-color: #dc3545 !important;
  border-color: #dc3545 !important;
  color: black !important;
}

/* File upload styles */
.file-upload-container {
  margin-top: 8px;
}

.file-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  margin-bottom: 4px;
  border-radius: 4px;
  background-color: #f8f8f8;
}

.file-name {
  font-size: 0.875rem;
  color: #555;
  margin-right: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

.text-danger {
  color: #dc3545;
}

.text-success {
  color: #28a745;
}
</style>
